module.exports = __webpack_public_path__ + "static/media/19-d-calendar.f18dbec3.png";